import * as React from "react";

export function useInterval(callback: () => void, interval: number | null) {
  const savedCallback = React.useRef(callback);

  // Memoize the callback, so it doesn't trigger changes of the interval:
  React.useLayoutEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  React.useEffect(() => {
    if (interval === null) {
      return;
    }

    const id = setInterval(() => {
      savedCallback.current();
    }, interval);

    return () => {
      clearInterval(id);
    };
  }, [interval]);
}
